(() => {
  const bars = document.querySelectorAll('[data-cc-sticky-buy]');
  bars.forEach((bar) => {
    const nativeButton = document.querySelector('.product-form__submit[name="add"]');
    const trigger = bar.querySelector('[data-cc-add-trigger]');
    const nativePrice = document.querySelector('.product__info-container .price');
    const stickyPrice = bar.querySelector('[data-cc-sticky-price]');
    if (!nativeButton || !trigger) return;
    const sync = () => {
      trigger.disabled = nativeButton.disabled;
      const label = nativeButton.querySelector('span')?.textContent?.trim();
      if (label) trigger.textContent = label;
    };
    sync();
    new MutationObserver(sync).observe(nativeButton, { attributes: true, childList: true, subtree: true });
    if (nativePrice && stickyPrice) {
      const syncPrice = () => {
        const candidates = [...nativePrice.querySelectorAll('.price-item')];
        const visiblePrice = candidates.find((item) => getComputedStyle(item).display !== 'none' && item.offsetParent !== null);
        if (visiblePrice) stickyPrice.textContent = visiblePrice.textContent.trim();
      };
      syncPrice();
      new MutationObserver(syncPrice).observe(nativePrice, { attributes: true, childList: true, subtree: true });
    }
    trigger.addEventListener('click', () => nativeButton.click());
    const observer = new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    observer.observe(nativeButton);
  });
})();
